import { GallerySceneType } from '../CommonTypes';
import { useGallerySceneLocationSVG } from '../hooks/useGallerySceneLocationSVG';
import useGalleryScenes from '../hooks/useGalleryScenes';
// import useSite from '../hooks/useSite';

export const PanoramaHotSpots = ({
  currentScene,
  setSelectedScene,
}: {
  currentScene: GallerySceneType;
  setSelectedScene: (view: GallerySceneType) => void;
}) => {
  const [locationsSvg] = useGallerySceneLocationSVG(currentScene?.svgurl);
  // const [site] = useSite();
  // const [locationsSvg] = useGallerySceneLocationSVG(`/svg/enklahem/${site.sitename}/scenes/${currentScene.name}.svg`);
  const [galleryScenes] = useGalleryScenes('cube');

  return (
    <div className="view360-hotspots">
      {locationsSvg?.map((loc, index) => (
        <button
          key={`hotspotlinks-${index}`}
          className="view360-hotspot flex h-8 w-8 items-center justify-center rounded-full bg-white font-bold text-black"
          data-yaw={loc.yaw}
          data-pitch={loc.pitch}
          onClick={() => setSelectedScene(galleryScenes[loc.ref_id as unknown as number])}
        >
          {index + 10}
        </button>
      ))}
    </div>
  );
};
